import type { RuntimeConfig } from '@/config/runtimeConfig'

export type CampaignPromoContent = {
  headline: string
  termsLabel: string
  termsHref: string
  ctaLabel: string
  ctaHref: string
}

/**
 * Shown until marketing sets the CAMPAIGN_PROMO_* runtime config keys for an environment
 * (see runtimeConfig.ts) — also what Storybook and unit tests render against. Copy and
 * destinations are placeholders lifted from the reference frames, not Portal source: the
 * live banner there is overridden client-side by marketing's GTM tag, so there is no
 * server-rendered content to port.
 */
export const DEFAULT_CAMPAIGN_PROMO: CampaignPromoContent = {
  headline: 'Unlimited data. £12 a month.',
  termsLabel: 'Terms apply',
  termsHref: 'https://www.giffgaff.com/terms',
  ctaLabel: 'Bag this deal',
  ctaHref: '/sim-only-deals',
}

/**
 * Resolves campaign promo content from runtime config, falling back field-by-field to
 * DEFAULT_CAMPAIGN_PROMO. Field-by-field (not all-or-nothing) so an environment can
 * override just the CTA destination for a new deal without also having to repeat the
 * headline and terms link.
 */
export function getCampaignPromoContent(runtimeConfig: RuntimeConfig): CampaignPromoContent {
  return {
    headline: runtimeConfig.CAMPAIGN_PROMO_HEADLINE || DEFAULT_CAMPAIGN_PROMO.headline,
    termsLabel: runtimeConfig.CAMPAIGN_PROMO_TERMS_LABEL || DEFAULT_CAMPAIGN_PROMO.termsLabel,
    termsHref: runtimeConfig.CAMPAIGN_PROMO_TERMS_HREF || DEFAULT_CAMPAIGN_PROMO.termsHref,
    ctaLabel: runtimeConfig.CAMPAIGN_PROMO_CTA_LABEL || DEFAULT_CAMPAIGN_PROMO.ctaLabel,
    ctaHref: runtimeConfig.CAMPAIGN_PROMO_CTA_HREF || DEFAULT_CAMPAIGN_PROMO.ctaHref,
  }
}
